/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'
import QS from 'qs'
import Vue from 'vue'
import router from '../router/index.js'



// 开发环境使用代理，生产环境使用完整URL
axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '' : 'https://rzwl.bjxtwlkj.com/rzwl'

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.headers['Access-Control-Allow-Origin'] = '*';

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // config.headers.token = token // 请求头部添加token
    if (sessionStorage.getItem('token')) {
      const token = sessionStorage.getItem('token')
      // token && (config.headers.Authorization = token);
      // // config.headers.Authorization = sessionStorage.getItem('token');
      config.headers['X-Mall-Token'] = sessionStorage.getItem('token')
    } else {
      config.headers['X-Mall-Token'] = ''
      // config.headers.Authorization = ''
    }
    // console.log(config.headers.Authorization)

    // console.log(config.headers.token)
    return config
  },
  error => {
    return Promise.error(error)
  })

// // 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      if (response.data.code == 401) {
        router.push({ path: '/' })
      }
      if (response.data.code == 402) {
        router.push({ path: '/' })
      }
      return Promise.resolve(response)
    } else if (response.status === 203) {
      // token过期
      router.push({ 'path': '/' })
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是200的情况
  error => {
    console.log(error,'error')
    // debugger
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          alert(401)
          break
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          alert(403)
          break
        // 404请求不存在
        case 404:
          alert(404)
          break
        // 其他错误，直接抛出错误提示
        default:
      }
      return Promise.reject(error.response)
    }
  }
)
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, QS.stringify(params))
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
export function postFormData(url, params) {
  return axios({
    method: 'post',
    url: url,
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  })
}
export function postJson(url, params) {
  return axios({
    method: 'post',
    url: url,
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
export function put(url, params) {
  return axios({
    method: 'put',
    url: url,
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function putApplication(url, params) {
  return axios({
    method: 'put',
    url: url,
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}


export function deleteApplication(url, params) {
  return axios({
    method: 'delete',
    url: url,
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function deleteL(url, params) {
  return new Promise((resolve, reject) => {
    axios.delete(url, QS.stringify(params))
      .then(res => { //put封装和这个一样
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
